<template>
  <section class="custom-progress" :style="{ width: width + 'px' }">
    <vue-highcharts
      type="chart"
      ref="vchart"
      :options="options"
      :redrawOnUpdate="true"
      :oneToOneUpdate="false"
      :animateOnUpdate="isAnimate"
    />
  </section>
</template>
<script>
import VueHighcharts from 'vue3-highcharts'
import globals from '@/Plugins/globals'
export default {
  name: 'progress-gauge',
  components: {
    VueHighcharts,
  },
  props: {
    progress: {
      type: [Array, Number, String],
      default: 0,
    },
    dontAnimate: {
      type: Boolean,
      default: null,
    },
    width: {
      type: Number,
      default: 140,
    },
    ceiling: {
      type: Number,
      default: 100,
    },
  },
  mounted() {
    setTimeout(() => {
      window.app.$forceUpdate()
    }, 250)
  },
  computed: {
    isAnimate() {
      let _data = true
      if (this.dontAnimate) {
        _data = !this.dontAnimate
        // console.log("Don't Animate?", _data)
      }
      return _data
    },
    series() {
      let _series = [
        {
          name: '',
          borderColor: '#707070',
          borderWidth: 1,
          color: '#169900',
          pointWidth: 30,
          data: [0],
        },
      ]
      if (this.progress !== undefined && this.progress !== null) {
        if (Array.isArray(this.progress)) {
          let _color = ''
          let _name = ''
          _series = []
          for (var i = 0; i <= this.progress.length - 1; i++) {
            if (i === 0) {
              // thumbs down
              _name = 'down'
              _color = '#C42626'
            } else if (i === 1) {
              // neutral
              _name = 'neutral'
              _color = '#A3A3A3'
            } else {
              // thumbs up
              _name = 'up'
              _color = '#169900'
            }
            _series.push({
              name: _name,
              borderColor: '#707070',
              borderWidth: 1,
              color: _color,
              pointWidth: 30,
              data: [this.progress[i]],
            })
          }
        } else {
          _series.push({
            name: '',
            borderColor: '#707070',
            borderWidth: 1,
            color: '#169900',
            pointWidth: 30,
            data: [this.progress],
          })
        }
      }
      // console.log('Gauge Progress', {
      //   progress: this.progress,
      //   series: _series,
      // })
      return _series
    },
    options() {
      let _options = {
        chart: {
          defaultSeriesType: 'bar',
          plotBorderWidth: 2,
          plotBackgroundColor: '#CBEFC6',
          plotBorderColor: '#D8D8D8',
          plotShadow: false,
          height: 38,
          backgroundColor: 'transparent',
          marginTop: 0,
          spacing: [0, 0, 0, 0],
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '{series.name}: {point.y}%',
        },
        xAxis: {
          labels: {
            enabled: false,
          },
          tickLength: 0,
        },
        title: {
          text: null,
        },
        legend: {
          enabled: false,
        },
        yAxis: {
          title: {
            text: null,
          },
          labels: {
            enabled: false,
          },
          min: 0,
          max: this.ceiling,
          tickInterval: 20,
          minorTickInterval: 10,
          tickWidth: 1,
          tickLength: 8,
          minorTickLength: 5,
          minorTickWidth: 1,
          minorGridLineWidth: 0,
        },
        plotOptions: {
          series: {
            stacking: 'normal',
          },
        },
        series: this.series,
      }
      return _options
    },
  },
  methods: {
    refresh() {
      console.log('Refreshing the Gauge', this.progress)
      let chart = this.$refs.vchart.chart
      chart.redraw(this.options, true)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-progress {
  width: 140px;
  height: auto;
  text-align: center;
  margin: 0 auto;
}
</style>
